import { render } from "./Garage.vue?vue&type=template&id=853b3904&scoped=true"
import script from "./Garage.vue?vue&type=script&lang=js"
export * from "./Garage.vue?vue&type=script&lang=js"

import "./Garage.vue?vue&type=style&index=0&id=853b3904&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-853b3904"]])

export default __exports__